//id is the public_id file in cloudinary
import { slugify } from './UrlFactory'

export const getCloudinaryImageAttachment = (baseUrl, format, name, public_id) => {
  const slugifiedName = name ? slugify(name) : 'img';
  return baseUrl + '/fl_attachment:' + slugifiedName + '/' + public_id + '.' + format
}